import React from 'react';
import { DateFormater } from "../../../services/Helper";

const InquiryDetailHeader = ({ order, inquiry, shipmentTracking }) => {
  return (
    <div className="card rounded-4 mb-4">
      <header className="card-header bg-transparent p-4">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <span className="d-inline-block">
              <i className="far fa-calendar me-2" />
              {DateFormater(inquiry?.createdAt)}
            </span>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-md-end mt-2 mt-md-0">
            <span className="badge rounded-pill py-2 px-3 text-capitalize fs-12 bg-dark text-white">
              {inquiry.status}
            </span>
          </div>
        </div>
      </header>

      <div className="card-body p-4">
        <div className="row g-4">
          <CustomerInfo buyerInfo={order?.buyerInfo} />
          {/* Uncomment if needed */}
          {/* <DeliveryInfo shippingInfo={order?.shippingInfo} /> */}
          <ShipmentInfo shipmentTracking={shipmentTracking} />
        </div>
      </div>
    </div>
  );
};

const CustomerInfo = ({ buyerInfo }) => (
  <div className="col-12 col-md-4">
    <div className="d-flex flex-nowrap">
      <div className="icon-wrap me-3">
        <span className="rounded-circle px-4 py-3 bg-green-light text-green d-inline-block">
          <i className="fas fa-user" />
        </span>
      </div>
      <div className="media-body">
        <h6 className="mb-2">Customer</h6>
        <small className="d-block">{buyerInfo?.fullname} ({buyerInfo?.username})</small>
        <small className="d-block">{buyerInfo?.email}</small>
        <small className="d-block">{buyerInfo?.phone}</small>
      </div>
    </div>
  </div>
);

const ShipmentInfo = ({ shipmentTracking }) => (
  <div className="col-12 col-md-4">
    <div className="d-flex flex-nowrap">
      <div className="icon-wrap me-3">
        <span className="rounded-circle px-4 py-3 bg-green-light text-green d-inline-block">
          <i className="fas fa-truck" />
        </span>
      </div>
      <div className="media-body">
        <h6 className="mb-2">Shipment Tracking</h6>
        <p className="mb-1"><strong>Carrier:</strong> {shipmentTracking.carrier || "Not Provided"}</p>
        <p className="mb-1"><strong>Tracking Number:</strong> {shipmentTracking.trackingNumber || "Not Provided"}</p>
        <p className="mb-0"><strong>Status:</strong> {shipmentTracking.status || "Pending"}</p>
      </div>
    </div>
  </div>
);

// DeliveryInfo (optional)
// const DeliveryInfo = ({ shippingInfo }) => ( ... );

export default InquiryDetailHeader;
